export const mapUploadError = (err) => {
  const raw =
    err?.response?.data?.error ||
    err?.response?.data?.detail ||
    err?.message ||
    'Upload failed';

  const text = String(raw);

  if (text.includes('No space left on device')) {
    return {
      code: 'SERVER_DISK_FULL',
      message: 'Server storage is full. Uploads cannot continue right now.',
      raw: text,
    };
  }

  if (err?.response?.status === 413) {
    return {
      code: 'PAYLOAD_TOO_LARGE',
      message: 'File is too large for server limits.',
      raw: text,
    };
  }

  if (err?.response?.status === 401) {
    return {
      code: 'UNAUTHORIZED',
      message: 'Your session expired. Please sign in again.',
      raw: text,
    };
  }

  return {
    code: 'UPLOAD_ERROR',
    message: text,
    raw: text,
  };
};